import React from 'react';
import {Box, Typography} from '@mui/material';
import MoodBad from '@mui/icons-material/WifiOff';

const Error = () => (
  <Box
    display="flex"
    height="100vh"
    flexDirection="column"
    justifyContent="center"
    alignItems="center">
    <MoodBad fontSize="large" color="secondary" />
    <Box m={2} >
      <Typography textalign="center" variant="body1" component="p" color="secondary">
        Keine Internetverbindung vorhanden
      </Typography>
    </Box>
  </Box>
);

export default Error;
